"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sospirolo": {
    "e03eef01": [{
      "hkey": "07bb39aa",
      "slug": "sospirolo",
      "name": "Sospirolo",
      "primary": true,
      "skipSearch": false
    }],
    "pascoli": [{
      "hkey": "07bb39aa",
      "slug": "sospirolo",
      "name": "Sospirolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f5c63797": [{
      "hkey": "07bb39aa",
      "slug": "sospirolo",
      "name": "Sospirolo",
      "primary": true,
      "skipSearch": false
    }],
    "piz-camolino": [{
      "hkey": "07bb39aa",
      "slug": "sospirolo",
      "name": "Sospirolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "48bf816b": [{
      "hkey": "fc5381ad",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-susin": [{
      "hkey": "fc5381ad",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f15e9518": [{
      "hkey": "be8d6158",
      "slug": "gron-belvedere",
      "name": "Gron-Belvedere",
      "primary": true,
      "skipSearch": false
    }],
    "gron": [{
      "hkey": "be8d6158",
      "slug": "gron-belvedere",
      "name": "Gron-Belvedere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e8a1e3bc": [{
      "hkey": "9d778a96",
      "slug": "mis-mezzaterra",
      "name": "Mis-Mezzaterra",
      "primary": true,
      "skipSearch": false
    }],
    "mis": [{
      "hkey": "9d778a96",
      "slug": "mis-mezzaterra",
      "name": "Mis-Mezzaterra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;